import { Component } from 'react';

import './lockout-button.css';

class LockoutButton extends Component {
  render() {
    const { lockedout, click_func } = this.props;

    let buttonText = 'Lockout';
    let iconClass = 'lockout_icon fa fa-lock';
    let buttonClass = 'lockout_button lock';
    if (lockedout) {
      buttonText = 'Unlock';
      buttonClass = 'lockout_button unlock';
      iconClass = 'lockout_icon fa fa-unlock-alt';
    }

    return (
      <div id="lockdown_button_container">
        <button className={buttonClass} onClick={click_func}>
          {buttonText}
          <i className={iconClass}></i>
        </button>
      </div>
    );
  }
}

export default LockoutButton;
